import { render, staticRenderFns } from "./add-property.vue?vue&type=template&id=aa1f8d9a&"
import script from "./add-property.vue?vue&type=script&lang=js&"
export * from "./add-property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports